export default __webpack_public_path__ + "static/media/block.62f036fe.svg";